import { getCountryConfigByLocale } from './getCountryConfigByLocale'
import { useUserLocale } from './useUserLocale'

export { getCountryConfigByLocale }

export const useCountryConfig = () => {
  const userLocale = useUserLocale()

  return getCountryConfigByLocale(userLocale)
}
